<button [ngClass]="buttonCssClasses" [disabled]="disabled" (click)="onButtonClick($event)">
    <div class="d-flex" [ngClass]="contentCssClasses">
        <ng-container *ngIf="(innerState$ | async) === 'SUBMITTING'">
            <div class="pr-2">
                <fa-icon [icon]="faSpinner" [spin]="true"></fa-icon>
            </div>
            <div class="p-0" [innerHtml]="(submittingText$ | async) | translate"></div>
        </ng-container>
        <ng-container *ngIf="(innerState$ | async) === 'SUCCESS'">
            <div class="pr-2">
                <fa-icon [icon]="faCheck"></fa-icon>
            </div>
            <div class="p-0" [innerHtml]="(successText$ | async) | translate"></div>
        </ng-container>
        <ng-container *ngIf="(innerState$ | async) === 'ERROR'">
            <div class="pr-2">
                <fa-icon [icon]="faTimes"></fa-icon>
            </div>
            <div class="p-0" [innerHtml]="(errorText$ | async) | translate"></div>
        </ng-container>
        <ng-container *ngIf="(innerState$ | async) === 'DEFAULT'">
            <div class="p-0">
                <ng-content></ng-content>
            </div>
        </ng-container>
    </div>
</button>
